import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCallBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-2118d264-9b80-4553-aa22-8d17adc2dbc2",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .uuid-b771d75d-2e3b-4711-b632-47dcf2f14b21 {\n        fill: #3f5fac;\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		className: "uuid-b771d75d-2e3b-4711-b632-47dcf2f14b21",
		d: "M66.29,57.43l12.16,5.83c1.93.93.38,6.96-.79,8.67-1.84,2.68-4.92,4.46-8.02,5.39-4.2,1.25-8.26.36-12.28-.97-7.23-2.39-13.61-5.89-19.24-11.06-5.41-4.96-10.07-10.52-13.84-16.84-4.47-7.5-5.02-16.44,1.49-22.89,2.31-2.3,4.18-2.23,8.04-1.78.63.07,1.45,1.18,1.71,1.81l4.68,11.23c.43,1.03.53,2.06-.16,3.03-1.15,1.62-2.38,3.25-3.64,4.77-.85,1.02-.73,1.82-.09,2.9,4.56,7.75,11.3,13.65,19.69,16.89,1.2.46,2.09.44,2.95-.64l4.52-5.63c.66-.83,1.62-1.29,2.83-.71"
	})]
});
export default SvgCallBlue;
